export var CalendarEventType;
(function (CalendarEventType) {
    CalendarEventType[CalendarEventType["Generic"] = 1] = "Generic";
    CalendarEventType[CalendarEventType["MaintenanceTask"] = 2] = "MaintenanceTask";
    CalendarEventType[CalendarEventType["FieldTesting"] = 3] = "FieldTesting";
})(CalendarEventType || (CalendarEventType = {}));
//# sourceMappingURL=calendarEventType.enum.js.map